import React from 'react';
import './KeyDerivationConsentModal.css';

const KeyDerivationConsentModal = ({ isOpen, onConsent, onCancel, chainName, accountExists, isFirstTime = true, accountCoreSynced = true }) => {
    if (!isOpen) return null;

    if (!accountCoreSynced) {
        return (
            <div className="key-consent-overlay">
                <div className="key-consent-modal">
                    <div className="key-consent-header">
                        <h2>One moment</h2>
                    </div>
                    <div className="key-consent-content">
                        <p className="key-consent-intro">
                            Checking whether you already have a Stabletrust account for this wallet…
                        </p>
                    </div>
                    <div className="key-consent-actions">
                        <button type="button" className="key-consent-cancel" onClick={onCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Determine title and message based on whether account exists
    // Capitalize first letter of chain name for message (title already has proper case)
    const chainNameFormatted = chainName 
        ? chainName.charAt(0).toUpperCase() + chainName.slice(1).toLowerCase()
        : '';
    const title = accountExists 
        ? 'Enable Encryption' 
        : chainName 
            ? `Create Your ${chainName} Stabletrust Account`
            : 'Create Your Stabletrust Account';
    const message = accountExists 
        ? 'Sign with your wallet to enable encryption.'
        : chainNameFormatted
            ? `Sign with your wallet to create your ${chainNameFormatted} Stabletrust account.`
            : 'Sign with your wallet to create your Stabletrust account.';

    return (
        <div className="key-consent-overlay">
            <div className="key-consent-modal">
                <div className="key-consent-header">
                    <h2>{title}</h2>
                </div>
                
                <div className="key-consent-content">
                    <p className="key-consent-intro">
                        {message}
                    </p>
                </div>
                
                <div className="key-consent-actions">
                    <button 
                        className="key-consent-cancel"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button 
                        className="key-consent-approve"
                        onClick={onConsent}
                    >
                        Sign
                    </button>
                </div>
            </div>
        </div>
    );
};

export default KeyDerivationConsentModal;

